// Input sanitization helper
export const sanitizeAmount = value => {
  // Remove all characters except digits and decimal point
  let sanitized = value.replace(/[^\d.]/g, '');

  // Remove multiple decimal points, keep only the first one
  const parts = sanitized.split('.');
  if (parts.length > 2) {
    sanitized = parts[0] + '.' + parts.slice(1).join('');
  }

  return sanitized;
};

// Format number with thousand separators (optional, for display)
export const formatNumber = value => {
  if (!value || value === '') return '';

  const parts = value.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

// Input validation helper
export const validateAmount = (amount, balance, decimals = 6) => {
  if (!amount || amount.trim() === '') {
    return { valid: false, error: 'Please enter an amount' };
  }

  const numAmount = Number(amount);

  if (isNaN(numAmount)) {
    return { valid: false, error: 'Please enter a valid number' };
  }

  if (numAmount <= 0) {
    return { valid: false, error: 'Amount must be greater than zero' };
  }

  if (numAmount > Number(balance)) {
    return { valid: false, error: 'Amount exceeds your balance' };
  }

  // Check decimal places
  const decimalParts = amount.split('.');
  if (decimalParts.length > 1 && decimalParts[1].length > decimals) {
    return { valid: false, error: `Maximum ${decimals} decimal places allowed` };
  }

  return { valid: true, error: null };
};
